import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ITeklifDetay_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ITeklifDetay_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  StokDurumlariBelirtilmisMi: any[];
  StokDurumlariBelirtilmisMi_dummy: any[];
  Notify: boolean;
  Notify_dummy: boolean;
  KullaniciTeklifOnay: number;
  KullaniciTeklifOnay_dummy: number;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  GetKullanici: any[];
  GetKullanici_dummy: any[];
  GetTeklifMasTekli: any[];
  GetTeklifMasTekli_dummy: any[];
  GetTeklifDetay: any[];
  GetTeklifDetay_dummy: any[];
  HesaplaTeklifDetay: any[];
  HesaplaTeklifDetay_dummy: any[];
  GetTeklifGorusmeleri: any[];
  GetTeklifGorusmeleri_dummy: any[];
  UpdateStokOnay: number;
  UpdateStokOnay_dummy: number;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  InsertTeklifGorusmeleri: number;
  InsertTeklifGorusmeleri_dummy: number;
  isComp202823Visible: "visible" | "hidden";
  isComp740578Visible: "visible" | "hidden";
  isComp122018Visible: "visible" | "hidden";
  isComp236351Visible: "visible" | "hidden";
  isComp541458Visible: "visible" | "hidden";
  isComp696780Enabled: "enabled" | "disabled";
  isComp976661Enabled: "enabled" | "disabled";
  isComp241636Enabled: "enabled" | "disabled";
  isComp608033Enabled: "enabled" | "disabled";
}

export class TeklifDetay_ScreenBase extends React.PureComponent<
  ITeklifDetay_ScreenProps,
  any
> {
  teklifdetay_527622_value_kuikaTableRef: React.RefObject<any>;
  teklifdetay_608033_value_kuikaChatRef: React.RefObject<any>;
  ml = [
    {
      Id: "e6553d05-98ae-4ab8-be91-cc851f894a0b",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 202823,
          PropertyName: "label",
          Value: "Complete the Transaction",
          TagName: "Button1_label",
        },
        {
          Id: 423146,
          PropertyName: "value",
          Value: "Offer Number",
          TagName: "Label1_value",
        },
        {
          Id: 742470,
          PropertyName: "value",
          Value: "Revision Number",
          TagName: "Label3_value",
        },
        {
          Id: 534672,
          PropertyName: "value",
          Value: "Current Code",
          TagName: "Label4_value",
        },
        {
          Id: 748437,
          PropertyName: "value",
          Value: "History",
          TagName: "Label6_value",
        },
        {
          Id: 506333,
          PropertyName: "value",
          Value: "Situation",
          TagName: "Label6_value",
        },
        {
          Id: 854430,
          PropertyName: "value",
          Value: "Sender",
          TagName: "Label6_value",
        },
        {
          Id: 83707,
          PropertyName: "title",
          Value: "Picture",
          TagName: "TableTemplateColumn1_0_title",
        },
        {
          Id: 525300,
          PropertyName: "title",
          Value: "Stock Code",
          TagName: "TableTemplateColumn10_title",
        },
        {
          Id: 978338,
          PropertyName: "title",
          Value: "Stock Name",
          TagName: "TableTemplateColumn2_title",
        },
        {
          Id: 3470,
          PropertyName: "title",
          Value: "Brand",
          TagName: "TableTemplateColumn3_title",
        },
        {
          Id: 397575,
          PropertyName: "title",
          Value: "Amount",
          TagName: "TableTemplateColumn4_title",
        },
        {
          Id: 227028,
          PropertyName: "title",
          Value: "Discount Rates",
          TagName: "TableTemplateColumn6_title",
        },
        {
          Id: 106931,
          PropertyName: "title",
          Value: "Unit Price",
          TagName: "TableTemplateColumn7_title",
        },
        {
          Id: 980996,
          PropertyName: "title",
          Value: "Net PriceNet Price",
          TagName: "TableTemplateColumn9_title",
        },
        {
          Id: 361038,
          PropertyName: "title",
          Value: "Net Amount",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 523866,
          PropertyName: "title",
          Value: "Acceptance",
          TagName: "TableTemplateColumn11_title",
        },
        {
          Id: 721006,
          PropertyName: "title",
          Value: "Rejection",
          TagName: "TableTemplateColumn12_title",
        },
        {
          Id: 266522,
          PropertyName: "title",
          Value: "Revised",
          TagName: "TableTemplateColumn13_title",
        },
        {
          Id: 696196,
          PropertyName: "value",
          Value: "Offer Negotiations",
          TagName: "Label26_value",
        },
        {
          Id: 538542,
          PropertyName: "value",
          Value: "Payment Information",
          TagName: "Label29_value",
        },
        {
          Id: 731035,
          PropertyName: "value",
          Value: "Cart Information",
          TagName: "Label25_value",
        },
        {
          Id: 957686,
          PropertyName: "value",
          Value: "Total Amount",
          TagName: "Label29_value",
        },
        {
          Id: 233304,
          PropertyName: "value",
          Value: "Discount",
          TagName: "Label29_value",
        },
        {
          Id: 387257,
          PropertyName: "value",
          Value: "Net Amount",
          TagName: "Label29_value",
        },
        {
          Id: 976917,
          PropertyName: "value",
          Value: "Kdv",
          TagName: "Label29_value",
        },
        {
          Id: 3236,
          PropertyName: "value",
          Value: "General Discount 1",
          TagName: "Label47_value",
        },
        {
          Id: 201103,
          PropertyName: "value",
          Value: "General Discount 2",
          TagName: "Label51_value",
        },
        {
          Id: 592100,
          PropertyName: "value",
          Value: "General Discount 3",
          TagName: "Label48_value",
        },
        {
          Id: 154200,
          PropertyName: "value",
          Value: "Grand Total",
          TagName: "Label29_value",
        },
        {
          Id: 731885,
          PropertyName: "value",
          Value: "Payment Type",
          TagName: "Label28_value",
        },
        {
          Id: 10807958,
          PropertyName: "d8bde955-5898-56c5-278e-c53cc0e9a71f_notify",
          Value:
            "Selection fields cannot be empty. Please choose accept, reject, revise.",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 51029263,
          PropertyName: "e34479a8-37c2-f738-5bbe-af4facadda22_notify",
          Value: "Transaction Completed Successfully",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "f1e96f18-81d9-6312-1ebe-139d61cd7180",
      Name: "tr_TR",
      ShortName: "Turkish",
      LanguagePhrases: [],
    },
    {
      Id: "cd8e66ca-d8dd-1a05-bdac-f63ba9f6777b",
      Name: "fr_FR",
      ShortName: "French",
      LanguagePhrases: [],
    },
    {
      Id: "ef30cc19-66ab-ea0f-c492-2e57cb69ffd2",
      Name: "es_ES",
      ShortName: "Spanish",
      LanguagePhrases: [],
    },
    {
      Id: "2469e1a0-4509-4feb-8398-e1bf44b4075b",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 572355, PropertyName: "value", Value: "B2B Teklif Detayları" },
        { Id: 202823, PropertyName: "label", Value: "İşlemi Tamamla" },
        {
          Id: 423146,
          PropertyName: "value",
          Value: "B2B Teklif No   /   ERP Teklif No",
        },
        { Id: 308710, PropertyName: "value", Value: "/" },
        { Id: 742470, PropertyName: "value", Value: "Revize Numarası" },
        { Id: 534672, PropertyName: "value", Value: "Cari Kod" },
        { Id: 748437, PropertyName: "value", Value: "Tarih" },
        { Id: 506333, PropertyName: "value", Value: "Durum" },
        { Id: 854430, PropertyName: "value", Value: "Gönderen" },
        { Id: 83707, PropertyName: "title", Value: "Resim" },
        { Id: 525300, PropertyName: "title", Value: "Stok Kodu" },
        { Id: 366473, PropertyName: "value", Value: "[datafield:stokkodu]" },
        { Id: 978338, PropertyName: "title", Value: "Stok Adı" },
        { Id: 71886, PropertyName: "value", Value: "[datafield:stokadi]" },
        { Id: 3470, PropertyName: "title", Value: "Marka" },
        { Id: 8575, PropertyName: "value", Value: "[datafield:musterimarka]" },
        { Id: 397575, PropertyName: "title", Value: "Miktar" },
        { Id: 822622, PropertyName: "value", Value: "[datafield:miktar]" },
        { Id: 227028, PropertyName: "title", Value: "İskonto Oranları" },
        {
          Id: 851468,
          PropertyName: "value",
          Value: "[datafield:iskontooranlari]",
        },
        { Id: 106931, PropertyName: "title", Value: "Birim Fiyat" },
        { Id: 828780, PropertyName: "value", Value: "[datafield:birimfiyat]" },
        { Id: 980996, PropertyName: "title", Value: "Net Fiyat" },
        { Id: 769290, PropertyName: "value", Value: "[datafield:netfiyat]" },
        { Id: 361038, PropertyName: "title", Value: "Net Tutar" },
        { Id: 381902, PropertyName: "value", Value: "[datafield:nettutar]" },
        { Id: 523866, PropertyName: "title", Value: "Kabul" },
        { Id: 721006, PropertyName: "title", Value: "Red" },
        { Id: 266522, PropertyName: "title", Value: "Revize" },
        { Id: 696196, PropertyName: "value", Value: "Teklif Görüşmeleri" },
        { Id: 731035, PropertyName: "value", Value: "Sepet Bilgileri" },
        { Id: 731885, PropertyName: "value", Value: "Ödeme Tipi" },
        { Id: 538542, PropertyName: "value", Value: "Ödeme Bilgileri" },
        { Id: 957686, PropertyName: "value", Value: "Toplam Tutar" },
        { Id: 233304, PropertyName: "value", Value: "İskonto" },
        { Id: 387257, PropertyName: "value", Value: "Net Tutar" },
        { Id: 976917, PropertyName: "value", Value: "Kdv" },
        { Id: 3236, PropertyName: "value", Value: "Genel İskonto 1" },
        { Id: 201103, PropertyName: "value", Value: "Genel İskonto 2" },
        { Id: 592100, PropertyName: "value", Value: "Genel İskonto 3" },
        { Id: 154200, PropertyName: "value", Value: "Genel Toplam" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.teklifdetay_527622_value_kuikaTableRef = React.createRef();
    this.teklifdetay_608033_value_kuikaChatRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      StokDurumlariBelirtilmisMi: [],
      IfThenElse: false,
      GetKullanici: [],
      GetTeklifMasTekli: [],
      GetTeklifDetay: [],
      HesaplaTeklifDetay: [],
      GetTeklifGorusmeleri: [],
      UpdateStokOnay: 0,
      NAVIGATE: "",
      InsertTeklifGorusmeleri: 0,
      isComp202823Visible: "hidden",
      isComp740578Visible: "hidden",
      isComp122018Visible: "hidden",
      isComp236351Visible: "hidden",
      isComp541458Visible: "hidden",
      isComp696780Enabled: "disabled",
      isComp976661Enabled: "disabled",
      isComp241636Enabled: "disabled",
      isComp608033Enabled: "disabled",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("teklifdetay", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.TeklifDetayPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("teklifdetay", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("teklifdetay", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.TeklifDetayPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  TeklifDetayPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      currentUsername_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      TeklifNumarasi_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
      cariKod_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CariKodu ?? this.props.screenInputs.carikodu,
        "string"
      ),
      teklifNumarasi_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
      TeklifNumarasi_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
      CariKod_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CariKodu ?? this.props.screenInputs.carikodu,
        "string"
      ),
      teklifNumarasi_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeklifDetay/TeklifDetayPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetKullanici = result?.data.getKullanici;
    stateVars.GetTeklifMasTekli = result?.data.getTeklifMasTekli;
    formVars.teklifdetay_125264_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTeklifMasTekli !== undefined
        ? stateVars.GetTeklifMasTekli?.length > 0
          ? stateVars.GetTeklifMasTekli[0].teklifNumarasi
          : null
        : this.state.GetTeklifMasTekli?.length > 0
        ? this.state.GetTeklifMasTekli[0].teklifNumarasi
        : null
    );
    formVars.teklifdetay_314305_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTeklifMasTekli !== undefined
        ? stateVars.GetTeklifMasTekli?.length > 0
          ? stateVars.GetTeklifMasTekli[0].teklifNumarasi
          : null
        : this.state.GetTeklifMasTekli?.length > 0
        ? this.state.GetTeklifMasTekli[0].teklifNumarasi
        : null
    );
    formVars.teklifdetay_319833_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTeklifMasTekli !== undefined
        ? stateVars.GetTeklifMasTekli?.length > 0
          ? stateVars.GetTeklifMasTekli[0].revizeSiraNo
          : null
        : this.state.GetTeklifMasTekli?.length > 0
        ? this.state.GetTeklifMasTekli[0].revizeSiraNo
        : null
    );
    formVars.teklifdetay_813258_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTeklifMasTekli !== undefined
        ? stateVars.GetTeklifMasTekli?.length > 0
          ? stateVars.GetTeklifMasTekli[0].firmaKodu
          : null
        : this.state.GetTeklifMasTekli?.length > 0
        ? this.state.GetTeklifMasTekli[0].firmaKodu
        : null
    );
    formVars.teklifdetay_645435_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTeklifMasTekli !== undefined
        ? stateVars.GetTeklifMasTekli?.length > 0
          ? stateVars.GetTeklifMasTekli[0].teklifTarihi
          : null
        : this.state.GetTeklifMasTekli?.length > 0
        ? this.state.GetTeklifMasTekli[0].teklifTarihi
        : null
    );
    formVars.teklifdetay_859510_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTeklifMasTekli !== undefined
        ? stateVars.GetTeklifMasTekli?.length > 0
          ? stateVars.GetTeklifMasTekli[0].odemeTipi
          : null
        : this.state.GetTeklifMasTekli?.length > 0
        ? this.state.GetTeklifMasTekli[0].odemeTipi
        : null
    );
    stateVars.isComp202823Visible =
      (ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetTeklifMasTekli !== undefined
            ? stateVars.GetTeklifMasTekli?.length > 0
              ? stateVars.GetTeklifMasTekli[0].yeri
              : null
            : this.state.GetTeklifMasTekli?.length > 0
            ? this.state.GetTeklifMasTekli[0].yeri
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("O", "string")
      ) &&
        ReactSystemFunctions.isNotEqualTo(
          ReactSystemFunctions.toString(
            this,
            stateVars.GetTeklifMasTekli !== undefined
              ? stateVars.GetTeklifMasTekli?.length > 0
                ? stateVars.GetTeklifMasTekli[0].yeri
                : null
              : this.state.GetTeklifMasTekli?.length > 0
              ? this.state.GetTeklifMasTekli[0].yeri
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("P", "string")
        ) &&
        ReactSystemFunctions.isNotEqualTo(
          ReactSystemFunctions.toString(
            this,
            stateVars.GetTeklifMasTekli !== undefined
              ? stateVars.GetTeklifMasTekli?.length > 0
                ? stateVars.GetTeklifMasTekli[0].yeri
                : null
              : this.state.GetTeklifMasTekli?.length > 0
              ? this.state.GetTeklifMasTekli[0].yeri
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("R", "string")
        ) &&
        ReactSystemFunctions.isNotEqualTo(
          ReactSystemFunctions.toString(
            this,
            stateVars.GetTeklifMasTekli !== undefined
              ? stateVars.GetTeklifMasTekli?.length > 0
                ? stateVars.GetTeklifMasTekli[0].yeri
                : null
              : this.state.GetTeklifMasTekli?.length > 0
              ? this.state.GetTeklifMasTekli[0].yeri
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("H", "string")
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp696780Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetTeklifMasTekli !== undefined
            ? stateVars.GetTeklifMasTekli?.length > 0
              ? stateVars.GetTeklifMasTekli[0].yeri
              : null
            : this.state.GetTeklifMasTekli?.length > 0
            ? this.state.GetTeklifMasTekli[0].yeri
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("K", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp976661Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetTeklifMasTekli !== undefined
            ? stateVars.GetTeklifMasTekli?.length > 0
              ? stateVars.GetTeklifMasTekli[0].yeri
              : null
            : this.state.GetTeklifMasTekli?.length > 0
            ? this.state.GetTeklifMasTekli[0].yeri
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("K", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp241636Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetTeklifMasTekli !== undefined
            ? stateVars.GetTeklifMasTekli?.length > 0
              ? stateVars.GetTeklifMasTekli[0].yeri
              : null
            : this.state.GetTeklifMasTekli?.length > 0
            ? this.state.GetTeklifMasTekli[0].yeri
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("K", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp608033Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetTeklifMasTekli !== undefined
            ? stateVars.GetTeklifMasTekli?.length > 0
              ? stateVars.GetTeklifMasTekli[0].yeri
              : null
            : this.state.GetTeklifMasTekli?.length > 0
            ? this.state.GetTeklifMasTekli[0].yeri
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("K", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.GetTeklifDetay = result?.data.getTeklifDetay;

    stateVars.HesaplaTeklifDetay = result?.data.hesaplaTeklifDetay;
    formVars.teklifdetay_800616_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].toplamTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].toplamTutar
        : null
    );
    formVars.teklifdetay_325543_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].toplamIskontoTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].toplamIskontoTutar
        : null
    );
    formVars.teklifdetay_848695_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].netTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].netTutar
        : null
    );
    formVars.teklifdetay_224277_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].kdvTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].kdvTutar
        : null
    );
    formVars.teklifdetay_843596_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk1Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk1Tutar
        : null
    );
    formVars.teklifdetay_45669_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk2Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk2Tutar
        : null
    );
    formVars.teklifdetay_850547_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk3Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk3Tutar
        : null
    );
    formVars.teklifdetay_656059_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelToplam
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelToplam
        : null
    );
    stateVars.isComp740578Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].kdvTutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].kdvTutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp122018Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk1Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk1Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp236351Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk2Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk2Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp541458Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk3Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk3Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetTeklifGorusmeleri = result?.data.getTeklifGorusmeleri;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TeklifDetayPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeklifDetayPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.teklifdetay_125264_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTeklifMasTekli !== undefined
        ? stateVars.GetTeklifMasTekli?.length > 0
          ? stateVars.GetTeklifMasTekli[0].teklifNumarasi
          : null
        : this.state.GetTeklifMasTekli?.length > 0
        ? this.state.GetTeklifMasTekli[0].teklifNumarasi
        : null
    );

    stateVars.isComp202823Visible =
      (ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetTeklifMasTekli !== undefined
            ? stateVars.GetTeklifMasTekli?.length > 0
              ? stateVars.GetTeklifMasTekli[0].yeri
              : null
            : this.state.GetTeklifMasTekli?.length > 0
            ? this.state.GetTeklifMasTekli[0].yeri
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("O", "string")
      ) &&
        ReactSystemFunctions.isNotEqualTo(
          ReactSystemFunctions.toString(
            this,
            stateVars.GetTeklifMasTekli !== undefined
              ? stateVars.GetTeklifMasTekli?.length > 0
                ? stateVars.GetTeklifMasTekli[0].yeri
                : null
              : this.state.GetTeklifMasTekli?.length > 0
              ? this.state.GetTeklifMasTekli[0].yeri
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("P", "string")
        ) &&
        ReactSystemFunctions.isNotEqualTo(
          ReactSystemFunctions.toString(
            this,
            stateVars.GetTeklifMasTekli !== undefined
              ? stateVars.GetTeklifMasTekli?.length > 0
                ? stateVars.GetTeklifMasTekli[0].yeri
                : null
              : this.state.GetTeklifMasTekli?.length > 0
              ? this.state.GetTeklifMasTekli[0].yeri
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("R", "string")
        ) &&
        ReactSystemFunctions.isNotEqualTo(
          ReactSystemFunctions.toString(
            this,
            stateVars.GetTeklifMasTekli !== undefined
              ? stateVars.GetTeklifMasTekli?.length > 0
                ? stateVars.GetTeklifMasTekli[0].yeri
                : null
              : this.state.GetTeklifMasTekli?.length > 0
              ? this.state.GetTeklifMasTekli[0].yeri
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("H", "string")
        )) === true
        ? "visible"
        : "hidden";
    formVars.teklifdetay_314305_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTeklifMasTekli !== undefined
        ? stateVars.GetTeklifMasTekli?.length > 0
          ? stateVars.GetTeklifMasTekli[0].teklifNumarasi
          : null
        : this.state.GetTeklifMasTekli?.length > 0
        ? this.state.GetTeklifMasTekli[0].teklifNumarasi
        : null
    );

    formVars.teklifdetay_319833_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTeklifMasTekli !== undefined
        ? stateVars.GetTeklifMasTekli?.length > 0
          ? stateVars.GetTeklifMasTekli[0].revizeSiraNo
          : null
        : this.state.GetTeklifMasTekli?.length > 0
        ? this.state.GetTeklifMasTekli[0].revizeSiraNo
        : null
    );

    formVars.teklifdetay_813258_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTeklifMasTekli !== undefined
        ? stateVars.GetTeklifMasTekli?.length > 0
          ? stateVars.GetTeklifMasTekli[0].firmaKodu
          : null
        : this.state.GetTeklifMasTekli?.length > 0
        ? this.state.GetTeklifMasTekli[0].firmaKodu
        : null
    );

    formVars.teklifdetay_645435_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTeklifMasTekli !== undefined
        ? stateVars.GetTeklifMasTekli?.length > 0
          ? stateVars.GetTeklifMasTekli[0].teklifTarihi
          : null
        : this.state.GetTeklifMasTekli?.length > 0
        ? this.state.GetTeklifMasTekli[0].teklifTarihi
        : null
    );

    stateVars.dataSource_527622 =
      stateVars.GetTeklifDetay ?? this.state.GetTeklifDetay;
    stateVars.isComp696780Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetTeklifMasTekli !== undefined
            ? stateVars.GetTeklifMasTekli?.length > 0
              ? stateVars.GetTeklifMasTekli[0].yeri
              : null
            : this.state.GetTeklifMasTekli?.length > 0
            ? this.state.GetTeklifMasTekli[0].yeri
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("K", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp976661Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetTeklifMasTekli !== undefined
            ? stateVars.GetTeklifMasTekli?.length > 0
              ? stateVars.GetTeklifMasTekli[0].yeri
              : null
            : this.state.GetTeklifMasTekli?.length > 0
            ? this.state.GetTeklifMasTekli[0].yeri
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("K", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp241636Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetTeklifMasTekli !== undefined
            ? stateVars.GetTeklifMasTekli?.length > 0
              ? stateVars.GetTeklifMasTekli[0].yeri
              : null
            : this.state.GetTeklifMasTekli?.length > 0
            ? this.state.GetTeklifMasTekli[0].yeri
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("K", "string")
      ) === true
        ? "enabled"
        : "disabled";

    stateVars.dataSource_608033 =
      stateVars.GetTeklifGorusmeleri ?? this.state.GetTeklifGorusmeleri;
    stateVars.isComp608033Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetTeklifMasTekli !== undefined
            ? stateVars.GetTeklifMasTekli?.length > 0
              ? stateVars.GetTeklifMasTekli[0].yeri
              : null
            : this.state.GetTeklifMasTekli?.length > 0
            ? this.state.GetTeklifMasTekli[0].yeri
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("K", "string")
      ) === true
        ? "enabled"
        : "disabled";
    formVars.teklifdetay_859510_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTeklifMasTekli !== undefined
        ? stateVars.GetTeklifMasTekli?.length > 0
          ? stateVars.GetTeklifMasTekli[0].odemeTipi
          : null
        : this.state.GetTeklifMasTekli?.length > 0
        ? this.state.GetTeklifMasTekli[0].odemeTipi
        : null
    );

    formVars.teklifdetay_800616_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].toplamTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].toplamTutar
        : null
    );

    formVars.teklifdetay_325543_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].toplamIskontoTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].toplamIskontoTutar
        : null
    );

    formVars.teklifdetay_848695_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].netTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].netTutar
        : null
    );

    stateVars.isComp740578Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].kdvTutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].kdvTutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.teklifdetay_224277_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].kdvTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].kdvTutar
        : null
    );

    stateVars.isComp122018Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk1Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk1Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.teklifdetay_843596_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk1Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk1Tutar
        : null
    );

    stateVars.isComp236351Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk2Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk2Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.teklifdetay_45669_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk2Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk2Tutar
        : null
    );

    stateVars.isComp541458Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk3Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk3Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.teklifdetay_850547_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk3Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk3Tutar
        : null
    );

    formVars.teklifdetay_656059_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelToplam
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelToplam
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  TeklifDetayComponent_194744_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeklifDetayComponent_202823_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      TeklifNumarasi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeklifDetay/TeklifDetayComponent_202823_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.StokDurumlariBelirtilmisMi =
      result?.data.stokDurumlariBelirtilmisMi;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TeklifDetayComponent_202823_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeklifDetayComponent_202823_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "d8bde955_5898_56c5_278e_c53cc0e9a71f_notify",
        this.defaultML,
        "Seçim alanları boş olamaz. Lütfen kabul,red,revize seçimi yapın"
      ),
      ReactSystemFunctions.convertToTypeByName("warning", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      5,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  TeklifDetayComponent_202823_onClick_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      TeklifNumarasi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeklifDetay/TeklifDetayComponent_202823_onClick_else1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.KullaniciTeklifOnay = result?.data.kullaniciTeklifOnay;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TeklifDetayComponent_202823_onClick_else11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeklifDetayComponent_202823_onClick_else11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "e34479a8_37c2_f738_5bbe_af4facadda22_notify",
        this.defaultML,
        "İşlem Başarıyla Gerçekleşti"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      3,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  TeklifDetayComponent_202823_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.StokDurumlariBelirtilmisMi !== undefined
            ? stateVars.StokDurumlariBelirtilmisMi?.length > 0
              ? stateVars.StokDurumlariBelirtilmisMi[0].result
              : null
            : this.state.StokDurumlariBelirtilmisMi?.length > 0
            ? this.state.StokDurumlariBelirtilmisMi[0].result
            : null
        ),
        "0"
      )
    ) {
      isErrorOccurred = await this.TeklifDetayComponent_202823_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.TeklifDetayComponent_202823_onClick_else1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeklifDetayComponent_527622_onRowEditFinished = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "teklifdetay_527622_value", ".id"),
        "number"
      ),
      isOnay_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teklifdetay_696780_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      isRed_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teklifdetay_976661_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      isRevize_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teklifdetay_241636_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      cariKod_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CariKodu ?? this.props.screenInputs.carikodu,
        "string"
      ),
      teklifNumarasi_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
      TeklifNumarasi_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
      CariKod_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CariKodu ?? this.props.screenInputs.carikodu,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeklifDetay/TeklifDetayComponent_527622_onRowEditFinished",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UpdateStokOnay = result?.data.updateStokOnay;
    stateVars.GetTeklifDetay = result?.data.getTeklifDetay;

    stateVars.HesaplaTeklifDetay = result?.data.hesaplaTeklifDetay;
    formVars.teklifdetay_800616_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].toplamTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].toplamTutar
        : null
    );
    formVars.teklifdetay_325543_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].toplamIskontoTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].toplamIskontoTutar
        : null
    );
    formVars.teklifdetay_848695_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].netTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].netTutar
        : null
    );
    formVars.teklifdetay_224277_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].kdvTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].kdvTutar
        : null
    );
    formVars.teklifdetay_843596_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk1Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk1Tutar
        : null
    );
    formVars.teklifdetay_45669_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk2Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk2Tutar
        : null
    );
    formVars.teklifdetay_850547_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk3Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk3Tutar
        : null
    );
    formVars.teklifdetay_656059_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelToplam
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelToplam
        : null
    );
    stateVars.isComp740578Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].kdvTutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].kdvTutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp122018Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk1Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk1Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp236351Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk2Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk2Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp541458Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk3Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk3Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TeklifDetayComponent_527622_onRowEditFinished1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeklifDetayComponent_527622_onRowEditFinished1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_527622 =
      stateVars.GetTeklifDetay ?? this.state.GetTeklifDetay;
    formVars.teklifdetay_800616_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].toplamTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].toplamTutar
        : null
    );

    formVars.teklifdetay_325543_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].toplamIskontoTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].toplamIskontoTutar
        : null
    );

    formVars.teklifdetay_848695_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].netTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].netTutar
        : null
    );

    formVars.teklifdetay_224277_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].kdvTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].kdvTutar
        : null
    );

    formVars.teklifdetay_843596_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk1Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk1Tutar
        : null
    );

    formVars.teklifdetay_45669_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk2Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk2Tutar
        : null
    );

    formVars.teklifdetay_850547_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk3Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk3Tutar
        : null
    );

    formVars.teklifdetay_656059_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelToplam
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelToplam
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeklifDetayComponent_725240_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "Resimler",
      "StokKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "teklifdetay_527622_value",
          "stokKodu"
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "TeklifDetay",
      "Resimler",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "139271",
      null,
      null,
      "true",
      "600px",
      "600px",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeklifDetayComponent_696780_onChange_if0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "teklifdetay_527622_value", "id"),
        "number"
      ),
      isOnay_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      isRed_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "teklifdetay_527622_value", "isRed"),
        "boolean"
      ),
      isRevize_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "teklifdetay_527622_value",
          "isRevize"
        ),
        "boolean"
      ),
      cariKod_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CariKodu ?? this.props.screenInputs.carikodu,
        "string"
      ),
      teklifNumarasi_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
      TeklifNumarasi_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
      CariKod_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CariKodu ?? this.props.screenInputs.carikodu,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeklifDetay/TeklifDetayComponent_696780_onChange_if0",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UpdateStokOnay = result?.data.updateStokOnay;
    stateVars.GetTeklifDetay = result?.data.getTeklifDetay;

    stateVars.HesaplaTeklifDetay = result?.data.hesaplaTeklifDetay;
    formVars.teklifdetay_800616_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].toplamTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].toplamTutar
        : null
    );
    formVars.teklifdetay_325543_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].toplamIskontoTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].toplamIskontoTutar
        : null
    );
    formVars.teklifdetay_848695_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].netTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].netTutar
        : null
    );
    formVars.teklifdetay_224277_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].kdvTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].kdvTutar
        : null
    );
    formVars.teklifdetay_843596_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk1Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk1Tutar
        : null
    );
    formVars.teklifdetay_45669_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk2Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk2Tutar
        : null
    );
    formVars.teklifdetay_850547_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk3Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk3Tutar
        : null
    );
    formVars.teklifdetay_656059_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelToplam
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelToplam
        : null
    );
    stateVars.isComp740578Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].kdvTutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].kdvTutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp122018Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk1Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk1Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp236351Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk2Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk2Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp541458Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk3Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk3Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  TeklifDetayComponent_696780_onChange_else0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "teklifdetay_527622_value", "id"),
        "number"
      ),
      isOnay_0: ReactSystemFunctions.convertToTypeByName(false, "boolean"),
      isRed_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "teklifdetay_527622_value", "isRed"),
        "boolean"
      ),
      isRevize_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "teklifdetay_527622_value",
          "isRevize"
        ),
        "boolean"
      ),
      cariKod_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CariKodu ?? this.props.screenInputs.carikodu,
        "string"
      ),
      teklifNumarasi_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
      TeklifNumarasi_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
      CariKod_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CariKodu ?? this.props.screenInputs.carikodu,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeklifDetay/TeklifDetayComponent_696780_onChange_else0",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UpdateStokOnay = result?.data.updateStokOnay;
    stateVars.GetTeklifDetay = result?.data.getTeklifDetay;

    stateVars.HesaplaTeklifDetay = result?.data.hesaplaTeklifDetay;
    formVars.teklifdetay_800616_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].toplamTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].toplamTutar
        : null
    );
    formVars.teklifdetay_325543_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].toplamIskontoTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].toplamIskontoTutar
        : null
    );
    formVars.teklifdetay_848695_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].netTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].netTutar
        : null
    );
    formVars.teklifdetay_224277_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].kdvTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].kdvTutar
        : null
    );
    formVars.teklifdetay_843596_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk1Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk1Tutar
        : null
    );
    formVars.teklifdetay_45669_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk2Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk2Tutar
        : null
    );
    formVars.teklifdetay_850547_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk3Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk3Tutar
        : null
    );
    formVars.teklifdetay_656059_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelToplam
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelToplam
        : null
    );
    stateVars.isComp740578Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].kdvTutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].kdvTutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp122018Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk1Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk1Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp236351Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk2Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk2Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp541458Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk3Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk3Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  TeklifDetayComponent_696780_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "teklifdetay_527622_value", "isOnay"),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      )
    ) {
      isErrorOccurred = await this.TeklifDetayComponent_696780_onChange_if0();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.TeklifDetayComponent_696780_onChange_else0();
      if (isErrorOccurred) return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeklifDetayComponent_976661_onChange_if0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "teklifdetay_527622_value", "id"),
        "number"
      ),
      isOnay_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "teklifdetay_527622_value", "isOnay"),
        "boolean"
      ),
      isRed_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      isRevize_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "teklifdetay_527622_value",
          "isRevize"
        ),
        "boolean"
      ),
      cariKod_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CariKodu ?? this.props.screenInputs.carikodu,
        "string"
      ),
      teklifNumarasi_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
      TeklifNumarasi_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
      CariKod_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CariKodu ?? this.props.screenInputs.carikodu,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeklifDetay/TeklifDetayComponent_976661_onChange_if0",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UpdateStokOnay = result?.data.updateStokOnay;
    stateVars.GetTeklifDetay = result?.data.getTeklifDetay;

    stateVars.HesaplaTeklifDetay = result?.data.hesaplaTeklifDetay;
    formVars.teklifdetay_800616_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].toplamTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].toplamTutar
        : null
    );
    formVars.teklifdetay_325543_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].toplamIskontoTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].toplamIskontoTutar
        : null
    );
    formVars.teklifdetay_848695_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].netTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].netTutar
        : null
    );
    formVars.teklifdetay_224277_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].kdvTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].kdvTutar
        : null
    );
    formVars.teklifdetay_843596_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk1Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk1Tutar
        : null
    );
    formVars.teklifdetay_45669_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk2Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk2Tutar
        : null
    );
    formVars.teklifdetay_850547_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk3Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk3Tutar
        : null
    );
    formVars.teklifdetay_656059_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelToplam
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelToplam
        : null
    );
    stateVars.isComp740578Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].kdvTutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].kdvTutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp122018Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk1Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk1Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp236351Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk2Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk2Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp541458Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk3Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk3Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  TeklifDetayComponent_976661_onChange_else0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "teklifdetay_527622_value", "id"),
        "number"
      ),
      isOnay_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "teklifdetay_527622_value", "isOnay"),
        "boolean"
      ),
      isRed_0: ReactSystemFunctions.convertToTypeByName(false, "boolean"),
      isRevize_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "teklifdetay_527622_value",
          "isRevize"
        ),
        "boolean"
      ),
      cariKod_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CariKodu ?? this.props.screenInputs.carikodu,
        "string"
      ),
      teklifNumarasi_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
      TeklifNumarasi_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
      CariKod_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CariKodu ?? this.props.screenInputs.carikodu,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeklifDetay/TeklifDetayComponent_976661_onChange_else0",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UpdateStokOnay = result?.data.updateStokOnay;
    stateVars.GetTeklifDetay = result?.data.getTeklifDetay;

    stateVars.HesaplaTeklifDetay = result?.data.hesaplaTeklifDetay;
    formVars.teklifdetay_800616_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].toplamTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].toplamTutar
        : null
    );
    formVars.teklifdetay_325543_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].toplamIskontoTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].toplamIskontoTutar
        : null
    );
    formVars.teklifdetay_848695_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].netTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].netTutar
        : null
    );
    formVars.teklifdetay_224277_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].kdvTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].kdvTutar
        : null
    );
    formVars.teklifdetay_843596_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk1Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk1Tutar
        : null
    );
    formVars.teklifdetay_45669_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk2Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk2Tutar
        : null
    );
    formVars.teklifdetay_850547_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk3Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk3Tutar
        : null
    );
    formVars.teklifdetay_656059_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelToplam
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelToplam
        : null
    );
    stateVars.isComp740578Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].kdvTutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].kdvTutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp122018Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk1Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk1Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp236351Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk2Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk2Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp541458Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk3Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk3Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  TeklifDetayComponent_976661_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "teklifdetay_527622_value", "isRed"),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      )
    ) {
      isErrorOccurred = await this.TeklifDetayComponent_976661_onChange_if0();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.TeklifDetayComponent_976661_onChange_else0();
      if (isErrorOccurred) return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeklifDetayComponent_241636_onChange_if0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "teklifdetay_527622_value", "id"),
        "number"
      ),
      isOnay_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "teklifdetay_527622_value", "isOnay"),
        "boolean"
      ),
      isRed_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "teklifdetay_527622_value", "isRed"),
        "boolean"
      ),
      isRevize_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      cariKod_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CariKodu ?? this.props.screenInputs.carikodu,
        "string"
      ),
      teklifNumarasi_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
      TeklifNumarasi_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
      CariKod_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CariKodu ?? this.props.screenInputs.carikodu,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeklifDetay/TeklifDetayComponent_241636_onChange_if0",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UpdateStokOnay = result?.data.updateStokOnay;
    stateVars.GetTeklifDetay = result?.data.getTeklifDetay;

    stateVars.HesaplaTeklifDetay = result?.data.hesaplaTeklifDetay;
    formVars.teklifdetay_800616_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].toplamTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].toplamTutar
        : null
    );
    formVars.teklifdetay_325543_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].toplamIskontoTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].toplamIskontoTutar
        : null
    );
    formVars.teklifdetay_848695_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].netTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].netTutar
        : null
    );
    formVars.teklifdetay_224277_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].kdvTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].kdvTutar
        : null
    );
    formVars.teklifdetay_843596_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk1Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk1Tutar
        : null
    );
    formVars.teklifdetay_45669_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk2Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk2Tutar
        : null
    );
    formVars.teklifdetay_850547_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk3Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk3Tutar
        : null
    );
    formVars.teklifdetay_656059_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelToplam
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelToplam
        : null
    );
    stateVars.isComp740578Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].kdvTutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].kdvTutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp122018Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk1Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk1Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp236351Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk2Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk2Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp541458Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk3Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk3Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  TeklifDetayComponent_241636_onChange_else0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "teklifdetay_527622_value", "id"),
        "number"
      ),
      isOnay_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "teklifdetay_527622_value", "isOnay"),
        "boolean"
      ),
      isRed_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "teklifdetay_527622_value", "isRed"),
        "boolean"
      ),
      isRevize_0: ReactSystemFunctions.convertToTypeByName(false, "boolean"),
      cariKod_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CariKodu ?? this.props.screenInputs.carikodu,
        "string"
      ),
      teklifNumarasi_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
      TeklifNumarasi_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
      CariKod_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CariKodu ?? this.props.screenInputs.carikodu,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeklifDetay/TeklifDetayComponent_241636_onChange_else0",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UpdateStokOnay = result?.data.updateStokOnay;
    stateVars.GetTeklifDetay = result?.data.getTeklifDetay;

    stateVars.HesaplaTeklifDetay = result?.data.hesaplaTeklifDetay;
    formVars.teklifdetay_800616_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].toplamTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].toplamTutar
        : null
    );
    formVars.teklifdetay_325543_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].toplamIskontoTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].toplamIskontoTutar
        : null
    );
    formVars.teklifdetay_848695_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].netTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].netTutar
        : null
    );
    formVars.teklifdetay_224277_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].kdvTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].kdvTutar
        : null
    );
    formVars.teklifdetay_843596_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk1Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk1Tutar
        : null
    );
    formVars.teklifdetay_45669_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk2Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk2Tutar
        : null
    );
    formVars.teklifdetay_850547_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk3Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk3Tutar
        : null
    );
    formVars.teklifdetay_656059_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelToplam
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelToplam
        : null
    );
    stateVars.isComp740578Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].kdvTutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].kdvTutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp122018Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk1Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk1Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp236351Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk2Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk2Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp541458Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk3Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk3Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  TeklifDetayComponent_241636_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "teklifdetay_527622_value",
          "isRevize"
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      )
    ) {
      isErrorOccurred = await this.TeklifDetayComponent_241636_onChange_if0();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.TeklifDetayComponent_241636_onChange_else0();
      if (isErrorOccurred) return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeklifDetayComponent_608033_onMessageSend = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Mesaj_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teklifdetay_608033_value",
            "message",
            "GetTeklifGorusmeleri",
            "",
            ""
          )
        ),
        "string"
      ),
      KullaniciAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      isPlasiyer_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        "boolean"
      ),
      TeklifNumarasi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
      teklifNumarasi_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeklifDetay/TeklifDetayComponent_608033_onMessageSend",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.InsertTeklifGorusmeleri = result?.data.insertTeklifGorusmeleri;
    stateVars.GetTeklifGorusmeleri = result?.data.getTeklifGorusmeleri;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TeklifDetayComponent_608033_onMessageSend1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeklifDetayComponent_608033_onMessageSend1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_608033 =
      stateVars.GetTeklifGorusmeleri ?? this.state.GetTeklifGorusmeleri;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [139271] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.TeklifDetayPageInit();
    }
  }
}
